const HsaFsa = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M9.8954 4.2041C10.8255 4.20512 11.5795 4.94705 11.5805 5.86248C11.5803 6.77807 10.8257 7.51984 9.8954 7.51997C8.96495 7.51997 8.21052 6.77816 8.21033 5.86248C8.21033 4.94664 8.96482 4.2041 9.8954 4.2041Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.31076 4.78645C5.23587 0.621451 11.0377 -0.421579 15.2701 2.4569C19.4984 5.34106 20.5559 11.05 17.6335 15.217C14.7068 19.378 8.90811 20.4184 4.67781 17.5412C0.44536 14.6624 -0.61445 8.95191 2.31076 4.78645ZM5.8 16.4368C8.33917 18.0275 11.5831 18.0329 14.128 16.451L9.95677 12.1658L5.8 16.4368ZM10.48 10.486L15.3593 15.4957C15.728 15.1441 16.0611 14.7579 16.3534 14.3426C17.1548 13.2018 17.6251 11.8668 17.7129 10.4825L10.48 10.486ZM2.22596 10.4816C2.2459 10.7798 2.28341 11.0765 2.33781 11.3703C2.62315 12.937 3.40341 14.3758 4.56776 15.4807L9.43181 10.4825L2.22596 10.4816ZM9.98568 2.36369C9.5131 2.36384 9.04143 2.40603 8.5766 2.48976C5.28401 3.08324 2.7478 5.68527 2.28189 8.9475H17.6515C17.1203 5.17941 13.851 2.37148 9.98568 2.36369Z"
      fill="currentColor"
    />
  </svg>
);

export { HsaFsa };
